<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col s9">

        <div v-if="loading" class="z-depth-1 white center-align" style="height: 250px">
          <div class="row" style="padding-top: 100px">
            <div class="preloader-wrapper active">
              <div class="spinner-layer spinner-white-only">
                <div class="circle-clipper left">
                  <div class="circle"></div>
                </div><div class="gap-patch">
                  <div class="circle"></div>
                </div><div class="circle-clipper right">
                  <div class="circle"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <span>Loading data...</span>
          </div>
        </div>

        <div v-if="!loading" v-for="(child, index) in childRailObjects" :key="index">
          <div v-show="selectedRailObjectIds.includes(child.UniqueId)" class="row">
            <div class="col s12">
              <div class="col s12 z-depth-1 white">
                <h5>{{child.Name}}</h5>
                <div v-if="measurements[child.UniqueId]">
                  <TrendChart :data="measurements[child.UniqueId].data" :dateTimeFrom="date.start" :dateTimeTo="date.end" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col s3">
        <div class="col s12 z-depth-1 white" style="height: 400px;">
          <h5>Filter</h5>
          <div class="input-field">
            <date-picker @input="dateChanged" v-model="date" :max-date="maxDate" @dateChanged="datePickerChanged" style="padding-right: 6px;" />
            <period-selector v-model="selectedPeriod" />
          </div>
          <div class="input-field">
            <li v-for="(child, index) in childRailObjects" v-bind:key="index" style="list-style: none;">
              <label>
                <input type="checkbox" @click="checkChanged(child.UniqueId)" :checked="selectedRailObjectIds.includes(child.UniqueId)"/>
                <span>{{ child.Name }}</span>
              </label>
            </li>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ComplexService from '@/services/ComplexService'
import DatePicker from '@/components/switch/DatePicker'
import SwitchApi from '@/services/api/switch/SwitchApi'
import TrendChart from './_trendChart.vue'
import RailObjectService from '../../../services/RailObjectService'
import Spinner from '@/components/Spinner'
import PeriodSelector from '@/components/PeriodSelector'

export default {
  components: {
    DatePicker,
    TrendChart,
    Spinner,
    PeriodSelector
  },
  props: {
    railObject: Object
  },
  data: function () {
    return {
      date: {
        start: moment().startOf('day').add(-1, 'w').utc().format(),
        end: moment().endOf('day').utc().format()
      },
      maxDate: new Date(),
      childRailObjects: [],
      measurements: {},
      selectedRailObjectIds: [],
      loading: false,
      selectedPeriod: '1week'
    }
  },
  mounted: async function () {
    await this.load()
  },
  methods: {
    load: async function () {
      this.loading = true

      const sw = await SwitchApi.getSwitch(this.railObject.RailObjectId, undefined)
      if (sw.data && sw.data.SwitchPeriodicObjects) {
        const children = []
        const allChildren = RailObjectService.getRailObjectChildren()
        for (let i = 0; i < sw.data.SwitchPeriodicObjects.length; i++) {
          children.push(allChildren.find(c => c.RailObjectId === sw.data.SwitchPeriodicObjects[i].RailObjectId))
        }
        this.selectedRailObjectIds = children.map(c => c.UniqueId)
        this.childRailObjects = children.filter(ro => ro).sort(ro => ro.Name)
      }

      await this.loadData()

      this.loading = false
    },
    loadData: async function () {
      this.loading = true

      const start = moment(this.date.start).startOf('day').utc().format()
      const end = moment(this.date.end).endOf('day').utc().format()
      const result = {}
      await Promise.all(this.childRailObjects.map(async (child) => {
        const statusUpdates = await ComplexService.GetStatusUpdatesAsync(this.railObject.UniqueId, child.UniqueId, start + '-til-' + end)
        result[child.UniqueId] = { railObject: child, data: statusUpdates.data }
      }))
      this.measurements = result

      this.loading = false
    },
    dateChanged: function () {
      this.loadData()
    },
    checkChanged: function (uniqueId) {
      if (this.selectedRailObjectIds.includes(uniqueId)) {
        this.selectedRailObjectIds = this.selectedRailObjectIds.filter(sa => sa !== uniqueId)
      } else {
        this.selectedRailObjectIds.push(uniqueId)
      }
    },
    datePickerChanged () {
      this.selectedPeriod = 'user_input'
      this.date.end = moment(this.date.end).endOf('day').utc()
    },
    getStartDate (endDate) {
      switch (this.selectedPeriod) {
        case '1week':
          return moment(endDate).subtract(1, 'weeks')
        case '2weeks':
          return moment(endDate).subtract(2, 'weeks')
        case '1month':
          return moment(endDate).subtract(1, 'months')
        case '3months':
          return moment(endDate).subtract(3, 'months')
        case '6months':
          return moment(endDate).subtract(6, 'months')
        case '1year':
          return moment(endDate).subtract(1, 'years')
        default:
          return moment(endDate).subtract(1, 'months')
      }
    }
  },
  watch: {
    selectedPeriod (period) {
      if (period === 'user_input') {
        return
      }
      const end = moment().endOf('day').format()
      const start = this.getStartDate(end).startOf('day').format()
      this.date = {
        start,
        end
      }
    }
  }
}
</script>

<style scoped>
.popover-container {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/mixedSignals/_trend/Trend.vue